module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"seat_management":"Seat Management","description":"Organize your team in Workspace. Simply add or remove seats in your selected plan."},"th":{"seat_management":"การจัดการที่นั่ง","description":"จัดการสามารถชิกใน Workspace สามารถเพิ่มและลดที่นั่งได้โดยไม่เกินจำนวนที่เลือกไว้"}}')
  delete Component.options._Ctor
}
